'use strict';

import raven from 'raven';
import angular from 'angular';

import SimpleMessages from 'app/controllers/simple-messages';

import AddTransactionController from './add-transaction.controller';
import AddTransactionTpl from './add-transaction.html';

import { sortByNameProp } from 'app/helpers/sorting';
import { getCashboxLabel } from '../../directives/cashbox-label';

class CashboxController {
  /* @ngInject */
  constructor(
    CashboxesService,
    OrderTranslationService,
    $scope,
    $mdDialog,
    $mdToast,
    $state
  ) {
    Object.assign(this, {
      CashboxesService,
      OrderTranslationService,
      $scope,
      $mdDialog,
      $mdToast,
      $state
    });
    Object.assign(this, SimpleMessages);

    this.query = {
      include: [
        {
          relation: 'src',
          scope: {
            include: 'employee'
          }
        },
        {
          relation: 'dst',
          scope: {
            include: 'employee'
          }
        }
      ],
      where: {},
      limit: 10,
      page: 1,
      order: 'createdAt DESC'
    };

    this.cashboxes = $scope.$parent.$resolve.cashboxes.sort(sortByNameProp);
    this.user = $scope.$parent.$resolve.user;

    if (this.user.isAdmin) {
      this.cashbox = this.cashboxes.find(c => c.id == 1);
    } else {
      this.cashbox = this.cashboxes.find(
        c => c.employeeId == this.user.employeeId
      );
    }

    if (!this.cashbox) {
      return this.$state.go('home');
    }

    this.getModels();

    this.onPagination = () => {
      this.getModels();
    };

    this.onReorder = () => {
      this.getModels();
    };
  }

  getModels() {
    let qOpts = JSON.parse(JSON.stringify(this.query));

    if (this.mdOrder) {
      qOpts.order = this.OrderTranslationService.translate(this.mdOrder);
    }

    qOpts.where.or = [
      {
        srcId: this.cashbox.id
      },
      {
        dstId: this.cashbox.id
      }
    ];

    let queryReady = this.CashboxesService.getTransactions(qOpts).then(
      transactions => {
        this.transactions = transactions;
      }
    );
    let countReady = this.CashboxesService.getTransactionsCount(qOpts).then(
      result => {
        this.transactionsCount = result.count;
      }
    );
    return Promise.all([queryReady, countReady]);
  }

  onCashboxChange() {
    this.getModels();
  }

  newCashboxTransaction(ev) {
    this.$mdDialog
      .show({
        controller: AddTransactionController,
        template: AddTransactionTpl,
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          cashboxLabel: getCashboxLabel(this.cashbox)
        }
      })
      .then(data => {
        this.showNewTransactionSpin = true;
        return this.CashboxesService.createAdjustment({
          id: this.cashbox.id,
          amount: data.amount,
          type: data.type,
          comments: data.comments
        })
          .then(result => {
            if (data.type == 'credit') {
              this.cashbox.balance += data.amount;
            } else if (data.type == 'debit') {
              this.cashbox.balance -= data.amount;
            }

            return result;
          })
          .then(
            result => {
              let newTx = result.transaction;
              newTx.src = this.cashboxes.find(c => c.id == newTx.srcId);
              newTx.dst = this.cashboxes.find(c => c.id == newTx.dstId);
              this.transactions.unshift(newTx);
              this.showNewTransactionSpin = false;
              this.simpleSuccess();
            },
            err => {
              this.showNewTransactionSpin = false;
              raven.captureException(err);
              this.simpleError();
            }
          );
      });
  }

  getLink(tx) {
    if (tx.metadata && tx.metadata.linkTo) {
      return (
        '/' + tx.metadata.linkTo.collectionUrl + '/' + tx.metadata.linkTo.id
      );
    }
  }

  hasLink(tx) {
    if (tx.metadata.type == 'cashboxTransfer') {
      return false;
    }
    return tx.metadata && tx.metadata.linkTo ? true : false;
  }

  getCreditAmount(tx) {
    if (tx.dst && tx.dst.id == this.cashbox.id) {
      return tx.amount;
    }
  }

  getDebitAmount(tx) {
    if (tx.src && tx.src.id == this.cashbox.id) {
      return tx.amount * -1;
    }
  }

  getCurrentBalance(tx) {
    if (tx.src && tx.src.id == this.cashbox.id) {
      return tx.currentSrcBalance;
    } else if (tx.dst && tx.dst.id == this.cashbox.id) {
      return tx.currentDstBalance;
    }
  }
}

export { CashboxController as default };
